import * as Sentry from '@sentry/react';

const isLocalHostname = (hostname: string): boolean =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

const isRunningOnLocalhost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return isLocalHostname(window.location.hostname);
};

const isLocalUrl = (url: string | undefined): boolean => {
  if (!url) {
    return false;
  }
  try {
    return isLocalHostname(new URL(url).hostname);
  } catch {
    return false;
  }
};

export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  if (!dsn || isRunningOnLocalhost()) {
    return;
  }

  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV ?? 'development',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    beforeSend(event) {
      if (isLocalUrl(event.request?.url)) {
        return null;
      }
      return event;
    },
  });
}

export function setSentryUser(userId: string): void {
  Sentry.setUser({ id: userId });
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}

export { Sentry };
